import { mergeClasses } from "@fluentui/react-components";
import { useStyles } from "./WorkspaceDocuments.styles";
import { ArrowLeftIcon } from "../icons/ProjectIqIcons";

const MAX_VISIBLE_ANCESTOR_SEGMENTS = 3;

export interface IContextFilesBreadcrumbProps {
  pathSegments: string[];
  onNavigateToBreadcrumbSegment: (index: number) => void;
  onNavigateUp: () => void;
}

export const ContextFilesBreadcrumb = ({
  pathSegments,
  onNavigateToBreadcrumbSegment,
  onNavigateUp,
}: IContextFilesBreadcrumbProps): JSX.Element => {
  const styles = useStyles();
  const isAtRoot = pathSegments.length === 0;

  const isCollapsed = pathSegments.length > MAX_VISIBLE_ANCESTOR_SEGMENTS + 1;
  const visiblePathSegments = isCollapsed
    ? pathSegments.slice(
        pathSegments.length - MAX_VISIBLE_ANCESTOR_SEGMENTS - 1,
      )
    : pathSegments;
  const hiddenSegmentCount = pathSegments.length - visiblePathSegments.length;

  return (
    <div className={styles.breadcrumbRow}>
      {!isAtRoot && (
        <button
          className={styles.breadcrumbBack}
          onClick={onNavigateUp}
          title="Go up one level"
          aria-label="Go up one level"
        >
          <ArrowLeftIcon size={16} />
        </button>
      )}

      <div className={styles.breadcrumbContainer}>
        <button
          className={mergeClasses(
            styles.breadcrumbSegment,
            styles.breadcrumbSegmentRoot,
            !isAtRoot && styles.breadcrumbSegmentAncestor,
          )}
          onClick={() => onNavigateToBreadcrumbSegment(-1)}
          title="Go to root"
        >
          All Files
        </button>

        {isCollapsed && (
          <span
            className={styles.breadcrumbSeparator}
            title={`${hiddenSegmentCount} hidden folder(s)`}
          >
            / …
          </span>
        )}

        {visiblePathSegments.map((segment, visibleIndex) => {
          const index = hiddenSegmentCount + visibleIndex;
          return (
            <div
              key={`${segment}-${index}`}
              className={styles.breadcrumbSegmentWrapper}
            >
              <span className={styles.breadcrumbSeparator}>/</span>
              <button
                className={mergeClasses(
                  styles.breadcrumbSegment,
                  index < pathSegments.length - 1 &&
                    styles.breadcrumbSegmentAncestor,
                )}
                onClick={() => onNavigateToBreadcrumbSegment(index)}
                title={segment}
              >
                {segment}
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};
